export const buttonColors = ["primary", "secondary", "tertiary"] as const;

export const buttonVariants = ["contained", "outlined", "text"] as const;

export const buttonSizes = ["small", "large"] as const;

export type ButtonColor = (typeof buttonColors)[number];

export type ButtonVariant = (typeof buttonVariants)[number];

export type ButtonSize = (typeof buttonSizes)[number];
